import { render, staticRenderFns } from "./SuggestionForm.vue?vue&type=template&id=16a8d48f&scoped=true"
import script from "./SuggestionForm.vue?vue&type=script&lang=js"
export * from "./SuggestionForm.vue?vue&type=script&lang=js"
import style0 from "./SuggestionForm.vue?vue&type=style&index=0&id=16a8d48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8d48f",
  null
  
)

export default component.exports